import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import {
  Paper,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import type { ButtonGroupListProps as Props } from './types';

export const ButtonGroupList = memo(
  ({ className, items, onChange, open }: Props) => {
    const handleChange = (
      event: React.MouseEvent<HTMLElement>,
      newValue: string
    ) => {
      if (newValue) onChange(newValue);
    };

    return (
      <Paper className={classnames('ButtonGroupList', className)}>
        <ToggleButtonGroup
          onChange={handleChange}
          value={open}
          exclusive
          fullWidth
        >
          {items.map((item) => {
            return (
              <Tooltip
                key={item.name}
                title="Coming Soon"
                disableHoverListener={!item.comingSoon}
              >
                <Styled.TooltipChildWrapper>
                  <ToggleButton
                    disabled={item.disabled}
                    size="xsmall"
                    value={item.field!}
                    key={item.key}
                  >
                    {item.metadata?.tabs?.icon && (
                      <Icon
                        name={item.metadata?.tabs?.icon}
                        size={18}
                        // color={
                        //   item.field! === open
                        //     ? item.metadata?.tabs?.iconColor
                        //     : undefined
                        // }
                      />
                    )}
                    <Typography
                      variant="body5"
                      // color={item.field! === open ? 'primary.500' : 'inherit'}
                    >
                      {item.name}
                    </Typography>
                  </ToggleButton>
                </Styled.TooltipChildWrapper>
              </Tooltip>
            );
          })}
        </ToggleButtonGroup>
      </Paper>
    );
  }
);

ButtonGroupList.displayName = 'ButtonGroupList';
